import { render } from "./ConfirmModal.vue?vue&type=template&id=1a97167b&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=1a97167b&scoped=true&lang=css"

import exportComponent from "/app/okta-hosted-login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a97167b"]])

export default __exports__